import { useLanguage } from "@/i18n/LanguageContext";

export const Marquee = () => {
  const { t } = useLanguage();
  return (
    <div data-testid="compliance-marquee"
      className="relative overflow-hidden border-y border-gold/15 bg-navy-deep py-5">
      <div className="flex w-max animate-marquee items-center">
        {[...t.marquee, ...t.marquee].map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="whitespace-nowrap font-serif text-lg italic tracking-wide text-slate-400">
              {item}
            </span>
            <span className="mx-10 inline-block h-1.5 w-1.5 rotate-45 border border-gold/60" />
          </span>
        ))}
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-navy-deep to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-navy-deep to-transparent" />
    </div>
  );
};
